export const DEVELOPMENT_AREAS_API = {
  COUNT: '/queries/development_areas/count',
} as const;

export const SOURCE_DOCUMENT_ASSIGNMENT_DROPDOWN_ITEMS = [
  { id: 'assigned', text: 'Assigned' },
  { id: 'unassigned', text: 'Unassigned' },
];
